class EyeInfoService {
  ValidRanges = {
    SPH: {
      min: -20,
      max: 20,
      step: 0.25,
      precision: 2,
      showPositiveSignal: true,
      allowedWords: ["plano"]
    },
    CYL: {
      min: -6,
      max: 6,
      step: 0.25,
      precision: 2,
      showPositiveSignal: true,
      allowedWords: ["sph"]
    },
    AXS: {
      min: 0,
      max: 180,
      step: 1,
      precision: 0,
      showPositiveSignal: false
    },
    POW: {
      min: 0.5,
      max: 3.5,
      step: 0.25,
      precision: 2,
      showPositiveSignal: true
    },
    DIS: {
      min: 1,
      max: null,
      step: 1,
      precision: 0,
      showPositiveSignal: false
    },
    BC: {
      min: 1,
      max: null,
      step: 0.1,
      precision: 1,
      showPositiveSignal: false
    },
    DIA: {
      min: 1,
      max: null,
      step: 0.1,
      precision: 1,
      showPositiveSignal: false
    },
    QT: {
      min: 1,
      max: null,
      step: 1,
      precision: 0,
      showPositiveSignal: false
    }
  }

  preventOutOfRange(event, config) {
    const val = event.target.value
    if (val.length > 0) {
      return this.formatValue(val, config)
    }

    return ""
  }

  formatValue(val, config) {
    if (!val || val.length == 0) {
      return ""
    }

    let clean = val
    if (typeof clean !== "number") {
      clean = val.replace("+", "").replace("20/", "")
    }

    const float = parseFloat(clean)
    if (isNaN(float)) {
      return this.parseAllowedWords(val, config.allowedWords)
    }

    const value = parseFloat(this.roundFloat(float, config.step, config.precision))
    const valueInRange = this.getValueInRange(value, config.min, config.max)
    const floatValue = this.roundFloat(valueInRange, config.step, config.precision)

    if (config.showPositiveSignal) {
      return this.formatPositiveSignal(floatValue)
    }

    return floatValue
  }

  getValueInRange(value, minimum, maximum) {
    const min = Math.max(value, minimum)
    const max = Math.min(value, maximum)

    if (max === null || max === maximum) {
      return maximum
    }

    if (min === null || min === minimum) {
      return minimum
    }

    return value
  }

  roundFloat(value, toNearest, fixed) {
    return (Math.round(value / toNearest) * toNearest).toFixed(fixed);
  }

  formatPositiveSignal(value) {
    return value > 0 ? `+${value}` : value
  }

  removePositiveSignal(value, words) {
    if (typeof value === "number") {
      return value
    }

    if (!value) {
      return null
    }

    const inputValue = value.replace("+", "")
    const parsed = parseFloat(inputValue)
    return isNaN(parsed) ? this.parseAllowedWords(value, words) : parsed
  }

  parseAllowedWords(val, words) {
    if (words && words.length > 0) {
      if (words.includes(val.toLowerCase())) {
        return val
      }
    }

    return null
  }
}

export default new EyeInfoService()